import { BlobProvider } from '@react-pdf/renderer';
import { useDateFormatPreference } from '@witmetrics/data-store';
import Dialog from '@/components/Dialog';
import AttestPdf from '../AttestPdf';
import type { TraceabilityData } from '../types';
import { classes } from './utils';

export type PdfPreviewDialogProps = {
  logo: string;
  data: TraceabilityData;
  onClose: () => void;
};

export default function PdfPreviewDialog({
  logo,
  data,
  onClose,
}: PdfPreviewDialogProps) {
  const dateFormat = useDateFormatPreference();

  return (
    <Dialog className={classes.dialog} onClose={onClose}>
      <BlobProvider
        document={
          <AttestPdf logoSrc={logo} dateFormat={dateFormat} data={data} />
        }>
        {({ url, loading, error }) => {
          if (loading || !url) {
            return <div className={classes.loading}>Generating preview…</div>;
          }
          if (error) {
            return (
              <div className={classes.loading}>Failed to generate preview.</div>
            );
          }
          return <iframe className={classes.iframe} src={url} />;
        }}
      </BlobProvider>
    </Dialog>
  );
}
